<template>
  <div class="gadget infinite-list-wrapper">
    <el-table
      :data="topics"
      style="width: 100%;"
      size="mini"
      ref="topicTable"
      @row-click="goToTopic"
      :show-overflow-tooltip="true"
      row-class-name="table-topic"
    >
      <!--:row-class-name="tableRowClassName"-->
      <el-table-column prop="title" label="标题" min-width="150px">
        <template slot-scope="scope">
          <el-badge
            v-if="scope.row.display_order"
            class="pin"
            value="📌"
          ></el-badge>
          <closed-label v-if="scope.row.closed"></closed-label>
          {{ scope.row.title }}
          <PriceLabel :price="scope.row.price"></PriceLabel>
          <span class="read">
            <a
              :href="
                '/topics/' +
                  scope.row.id +
                  (scope.row.slug === null ? '' : '/' + scope.row.slug)
              "
              >「阅」</a
            >
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="view_count"
        label="浏览"
        width="50px"
        align="right"
      >
      </el-table-column>
      <el-table-column
        prop="reply_count"
        label="回复"
        width="50px"
        align="right"
      >
      </el-table-column>
    </el-table>
    <div v-if="fetching" class="text-center">
      <div class="loading-content">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      v-if="this.loadMoreMessage == '已加载全部数据'"
      class="text-center"
      width="100%"
    >
      {{ this.loadMoreMessage }}
    </div>
    <el-button
      v-else
      type="default"
      style="width: 100%;"
      v-on:click="fetchTopics"
      >{{ this.loadMoreMessage }}</el-button
    >
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import VueMasonry from "vue-masonry-css";
import ClosedLabel from "@/components/ClosedLabel";
import PriceLabel from "@/components/PriceLabel";

Vue.use(VueMasonry);

export default {
  components: {
    ClosedLabel,
    PriceLabel
  },
  props: {
    queryParams: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      fetching: false,
      topics: [],
      currentPage: 1,
      totalPage: 2,
      loadMoreMessage: "",
      loadedLatestPage: 0
    };
  },
  computed: {
    ...mapState(["topicsUrl", "currentCategoryId"]),
    queryObject: function() {
      return { ...this.queryParams, ...{ page: this.currentPage } };
    }
  },
  mounted: function() {
    this.fetchTopics();
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    goToTopic: function(topic) {
      let url =
        "/topics/" + topic.id + (topic.slug === null ? "" : "/" + topic.slug);
      window.open(url, "_blank");
    },
    encodedQueryString: function(url) {
      const ret = [];
      for (let d in this.queryObject) {
        ret.push(
          encodeURIComponent(d) + "=" + encodeURIComponent(this.queryObject[d])
        );
      }

      var connectSymbol = url.indexOf("?") === -1 ? "?" : "&";
      return url + (ret.length === 0 ? "" : connectSymbol + ret.join("&"));
    },
    fetchTopics: function() {
      if (this.currentPage > this.totalPage) {
        this.loadMoreMessage = "已加载全部数据";
        return;
      }
      if (this.currentPage <= this.loadedLatestPage) {
        return;
      }
      this.loadedLatestPage = this.currentPage;
      var url = this.topicsUrl;

      if (url === "") return;
      // this.topicsUrl ||
      // (window.location.pathname === "/"
      //   ? "/api/topics"
      //   : "/api" + window.location.pathname);
      this.loadMoreMessage = "";
      this.fetching = true;
      this.$axios.get(this.encodedQueryString(url)).then(response => {
        let topics = response.data.data;
        if (!topics.length) {
          this.loadMoreMessage = "暂无数据";
        }
        this.fetching = false;
        for (var topic in topics) {
          this.topics.push(topics[topic]);
        }
        window.scrollBy(0, -20 * topics.length);

        this.totalPage = response.data.meta.pagination.total_pages;
        this.currentPage++;
        if (this.currentPage > this.totalPage) {
          this.loadMoreMessage = "已加载全部数据";
        } else {
          this.loadMoreMessage = "点击或向下滚动加载更多";
        }
      });
    },
    scroll() {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.fetchTopics();
      }
    }
  }
};
</script>
<style>
.table-topic:hover {
  cursor: pointer;
}
.el-table .cell {
  white-space: nowrap !important;
}
</style>
